import type { ModuleClientContribution } from "@cms/module-api";
import { CatalogBlock, CartBlock, CheckoutBlock, AccountBlock, OrderBlock } from "./src/client/PageBlocks";
import { MiniCart, HeaderCartTrigger } from "./src/client/MiniCart";
import { WishlistHeader } from "./src/client/Wishlist";
import { QuickOrderBlock, quickOrderDefaults } from "./src/client/QuickOrder";
import {
  CategoryGridBlock,
  FeaturedProductBlock,
  ProductGridBlock,
  ShopNavigationBlock,
  categoryGridDefaults,
  featuredProductDefaults,
  productGridDefaults,
  shopNavigationDefaults,
} from "./src/client/storefront";
import {
  CartSummaryBlock,
  CategoryNavigationBlock,
  CategorySpotlightBlock,
  NewProductsBlock,
  ProductCarouselBlock,
  ProductCollectionBlock,
  ProductListBlock,
  SaleProductsBlock,
  cartSummaryBlockDefaults,
  categoryNavigationBlockDefaults,
  categorySpotlightBlockDefaults,
  newProductsBlockDefaults,
  productCarouselBlockDefaults,
  productCollectionBlockDefaults,
  productListBlockDefaults,
  saleProductsBlockDefaults,
} from "./src/client/storefront-collections";
import "./src/module.scss";

export { CartPage, CatalogPage, CategoryPage, CheckoutPage, OrderConfirmation, ProductPage } from "./src/client/pages";
export { AccountPage } from "./src/client/AccountPage";
export { MiniCart, HeaderCartTrigger } from "./src/client/MiniCart";
export { QuickOrderPage } from "./src/client/QuickOrder";

const module: ModuleClientContribution = {
  adminLayout: "immersive",
  blocks: [
    { type: "webshops:catalog", label: "Winkelcatalogus", icon: "storefront", component: CatalogBlock, defaults: () => ({ heading: { nl: "Winkel", en: "Shop", de: "Shop" }, sidebar: [], displayMode: "" }) },
    { type: "webshops:cart", label: "Winkelwagen", icon: "shopping_cart", component: CartBlock, defaults: () => ({ heading: { nl: "Winkelwagen", en: "Cart", de: "Warenkorb" } }) },
    { type: "webshops:checkout", label: "Afrekenen", icon: "payments", component: CheckoutBlock, defaults: () => ({ heading: { nl: "Afrekenen", en: "Checkout", de: "Kasse" } }) },
    { type: "webshops:account", label: "Mijn account", icon: "person", component: AccountBlock, defaults: () => ({ heading: { nl: "Mijn account", en: "My account", de: "Mein Konto" } }) },
    { type: "webshops:order-confirmation", label: "Bestelling ontvangen", icon: "task_alt", component: OrderBlock, defaults: () => ({ heading: { nl: "Bestelling ontvangen", en: "Order received", de: "Bestellung erhalten" } }) },
    {
      type: "webshops:quick-order",
      label: "Snel bestellen",
      icon: "playlist_add_shopping_cart",
      component: QuickOrderBlock,
      defaults: quickOrderDefaults,
    },
    {
      type: "webshops:product-grid",
      label: "Productraster",
      icon: "grid_view",
      component: ProductGridBlock,
      defaults: productGridDefaults,
    },
    {
      type: "webshops:product-collection",
      label: "Flexibele productcollectie",
      icon: "dashboard_customize",
      component: ProductCollectionBlock,
      defaults: productCollectionBlockDefaults,
    },
    {
      type: "webshops:product-carousel",
      label: "Productcarrousel",
      icon: "view_carousel",
      component: ProductCarouselBlock,
      defaults: productCarouselBlockDefaults,
    },
    {
      type: "webshops:product-list",
      label: "Productlijst",
      icon: "view_list",
      component: ProductListBlock,
      defaults: productListBlockDefaults,
    },
    {
      type: "webshops:sale-products",
      label: "Aanbiedingen",
      icon: "sell",
      component: SaleProductsBlock,
      defaults: saleProductsBlockDefaults,
    },
    {
      type: "webshops:new-products",
      label: "Nieuwe producten",
      icon: "new_releases",
      component: NewProductsBlock,
      defaults: newProductsBlockDefaults,
    },
    {
      type: "webshops:featured-product",
      label: "Uitgelicht product",
      icon: "featured_seasonal_and_gifts",
      component: FeaturedProductBlock,
      defaults: featuredProductDefaults,
    },
    {
      type: "webshops:category-grid",
      label: "Categorieraster",
      icon: "category",
      component: CategoryGridBlock,
      defaults: categoryGridDefaults,
    },
    {
      type: "webshops:category-navigation",
      label: "Categorienavigatie",
      icon: "account_tree",
      component: CategoryNavigationBlock,
      defaults: categoryNavigationBlockDefaults,
    },
    {
      type: "webshops:category-spotlight",
      label: "Categorie uitgelicht",
      icon: "category_search",
      component: CategorySpotlightBlock,
      defaults: categorySpotlightBlockDefaults,
    },
    {
      type: "webshops:shop-navigation",
      label: "Webshopnavigatie en zoeken",
      icon: "search",
      component: ShopNavigationBlock,
      defaults: shopNavigationDefaults,
    },
    {
      type: "webshops:cart-summary",
      label: "Winkelmandsamenvatting",
      icon: "shopping_bag",
      component: CartSummaryBlock,
      defaults: cartSummaryBlockDefaults,
    },
  ],
  adminNav: [
    {
      label: "Webshop",
      href: "/admin/module/webshops",
      icon: "storefront",
      notificationKey: "actionable",
    },
  ],
  siteComponent: MiniCart,
  headerComponent: ({ locale }) => <><WishlistHeader locale={locale} /><HeaderCartTrigger locale={locale} /></>,
};

export default module;
